(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["survey-attribution"]) return;
  try {
    
(function () {
  "use strict";
  var form = document.getElementById("ot-survey");
  if (!form) return;

  // Keys must match SurveyResponse.HOW_DID_YOU_HEAR_OPTIONS on the backend.
  var OPTIONS = [
    ["saw_in_wild", "Saw another child/parent with one"],
    ["friend_family", "Friend or family member told me about it"],
    ["ig_fb_ad", "Instagram / Facebook Ad"],
    ["tiktok", "TikTok"],
    ["ig_fb_post", "Instagram / Facebook Post"],
    ["google_search", "Google / Search"],
    ["influencer", "Influencer / Creator"],
    ["ai_llm", "AI Model (LLM)"]
  ];
  var OTHER = ["other", "Other"];
  var ENDPOINT = "https://perf.ollietot.com/api/survey/";
  var API_KEY = "VSeiAX1rdVEJdMDykV1pDlZ0nNC59vHN54HRgBwO+J4=";

  // Fisher-Yates; "Other" stays pinned last so randomization measures the
  // real channels against each other, not against the escape hatch.
  var shuffled = OPTIONS.slice();
  for (var i = shuffled.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp;
  }
  shuffled.push(OTHER);
  var displayedOrder = shuffled.map(function (o) { return o[0]; });

  var list = document.getElementById("survey-options");
  var otherWrap = document.getElementById("survey-other-wrap");
  var otherText = document.getElementById("survey-other-text");
  var submitBtn = document.getElementById("survey-submit");
  var errorEl = document.getElementById("survey-error");
  var thanksEl = document.getElementById("survey-thanks");

  shuffled.forEach(function (opt) {
    var label = document.createElement("label");
    label.className = "survey-option";
    var input = document.createElement("input");
    input.type = "radio";
    input.name = "heard_from";
    input.value = opt[0];
    var dot = document.createElement("span");
    dot.className = "survey-radio";
    var text = document.createElement("span");
    text.className = "survey-option-label";
    text.textContent = opt[1];
    label.appendChild(input);
    label.appendChild(dot);
    label.appendChild(text);
    list.appendChild(label);
  });

  // Timing: all values are ms since navigation start (performance.now()).
  var firstInteractionMs = null;
  var answerMs = null;

  list.addEventListener("pointerdown", function () {
    if (firstInteractionMs === null) firstInteractionMs = Math.round(performance.now());
  });
  list.addEventListener("keydown", function () {
    if (firstInteractionMs === null) firstInteractionMs = Math.round(performance.now());
  });
  list.addEventListener("change", function (e) {
    answerMs = Math.round(performance.now());
    if (firstInteractionMs === null) firstInteractionMs = answerMs;
    submitBtn.disabled = false;
    var isOther = e.target.value === "other";
    otherWrap.hidden = !isOther;
    if (isOther) otherText.focus();
    list.querySelectorAll(".survey-option").forEach(function (el) {
      el.classList.toggle("selected", el.querySelector("input").checked);
    });
  });

  var params = new URLSearchParams(window.location.search);
  var orderName = (params.get("order") || "").slice(0, 64);
  var doneKey = "ot_survey_how_did_you_hear:" + orderName;
  try {
    if (window.localStorage.getItem(doneKey)) {
      form.hidden = true;
      thanksEl.hidden = false;
    }
  } catch (e) { /* private mode */ }

  var sending = false;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var chosen = form.querySelector('input[name="heard_from"]:checked');
    if (!chosen || sending) return;
    sending = true;
    submitBtn.disabled = true;
    errorEl.hidden = true;

    var sessionId = "";
    try { sessionId = window.sessionStorage.getItem("ollietot_session_id") || ""; } catch (err) {}

    var payload = {
      survey_key: "how_did_you_hear",
      session_id: sessionId,
      order_name: orderName,
      answer: chosen.value,
      other_text: chosen.value === "other" ? otherText.value.slice(0, 500) : "",
      displayed_order: displayedOrder,
      dwell_ms: Math.round(performance.now()),
      time_to_first_interaction_ms: firstInteractionMs,
      time_to_answer_ms: answerMs,
      page_url: window.location.href.split("?")[0]
    };
    Object.keys(payload).forEach(function (k) {
      if (payload[k] === null || payload[k] === "") delete payload[k];
    });

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Analytics-Key": API_KEY },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (r) {
      if (!r.ok) throw new Error("survey submit failed: " + r.status);
      try { window.localStorage.setItem(doneKey, "1"); } catch (err) {}
      form.hidden = true;
      thanksEl.hidden = false;
      thanksEl.classList.add("is-in");
    }).catch(function () {
      sending = false;
      submitBtn.disabled = false;
      errorEl.hidden = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
